import {Badge} from 'platform/components';
import {Heading, HStack, Show, Text, VStack} from 'platform/foundation';

import type {ReactNode} from 'react';

import {isNotNil} from 'ramda';

export function StepIntro(props: {title: string; description: string; aside?: ReactNode}) {
  return (
    <HStack justify="space-between" align="flex-start" spacing={4}>
      <VStack spacing={1}>
        <Heading size={3}>{props.title}</Heading>
        <Text size="small" color="secondary">
          {props.description}
        </Text>
      </VStack>
      <Show when={props.aside}>{props.aside}</Show>
    </HStack>
  );
}

export function SectionLabel(props: {label: string; count?: number; action?: ReactNode}) {
  return (
    <HStack justify="space-between" align="center">
      <HStack spacing={2} align="center">
        <Text size="xSmall" color="secondary" alternative>
          {props.label.toUpperCase()}
        </Text>
        <Show when={isNotNil(props.count)}>
          <Badge value={props.count ?? 0} size="small" variant="subtle" colorScheme="neutral" />
        </Show>
      </HStack>
      <Show when={props.action}>{props.action}</Show>
    </HStack>
  );
}
